import React from 'react';
import { Line } from 'react-chartjs-2';
import './chartSetup';
import { useThemeMode } from '../theme';
import { buildLine } from './builders';
import { themePalette } from './palette';

// Line chart. `data` from charts.prepareLine [{ label, value }]; `label`
// is the optional y field key for the dataset name.
export default function LineViz({ data, label }) {
  useThemeMode();
  const { data: chartData, options } = buildLine(data, label, themePalette());
  return <Line data={chartData} options={options} />;
}
